import { render, staticRenderFns } from "./BroadcastMessage.vue?vue&type=template&id=7d621ff6&"
import script from "./BroadcastMessage.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports